import { Component, inject, PLATFORM_ID } from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { Router, RouterModule } from '@angular/router';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'topbar-widget',
    standalone: true,
    imports: [CommonModule, RouterModule, StyleClassModule, ButtonModule, RippleModule],
    template: `
        <header class="w-full z-6 bg-usina-gray transition-all shadow-none h-auto px-6">
            
            <nav class="flex w-full align-items-center justify-content-between py-4 relative">
                
                <a class="cursor-pointer block flex-shrink-0" (click)="router.navigate(['/'])">
                    <img src="/assets/img/logo.png" alt="Usina CoWork" class="block h-3rem md:h-4rem" />
                </a>

                <div class="block lg:hidden ml-auto">
                    <i pStyleClass="@next" enterFromClass="hidden" leaveToClass="hidden" [hideOnOutsideClick]="true" 
                       class="pi pi-bars text-4xl cursor-pointer text-900"></i>
                    
                    <div class="align-items-center hidden absolute left-0 w-full bg-black shadow-2 z-5"
                         style="top: 100%;">
                        <ul class="list-none p-4 m-0 flex flex-column w-full">
                            <li><a href="/#services" (click)="navigate('#services', $event)" pRipple class="nav-link-mobile block p-3">Membresías</a></li>
                            <li><a href="/#about"    (click)="navigate('#about', $event)"    pRipple class="nav-link-mobile block p-3">Usina</a></li>
                            <li><a href="/#hq"       (click)="navigate('#hq', $event)"       pRipple class="nav-link-mobile block p-3">Sedes</a></li>
                            <li><a href="/#footer"   (click)="navigate('#footer', $event)"   pRipple class="nav-link-mobile block p-3">Contacto</a></li>
                            <li>
                                <a [href]="loginUrl" pRipple class="nav-link-mobile block p-3 flex align-items-center gap-2">
                                    <i class="pi pi-user"></i>
                                    <span>Log in</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="hidden lg:flex align-items-center flex-grow-1 px-6">
                    <ul class="list-none p-0 m-0 flex align-items-center justify-content-between px-8 w-full gap-6">
                        <li><a href="/#services" (click)="navigate('#services', $event)" pRipple class="nav-link">Membresías</a></li>
                        <li><a href="/#about"    (click)="navigate('#about', $event)"    pRipple class="nav-link">Usina</a></li>
                        <li><a href="/#hq"       (click)="navigate('#hq', $event)"       pRipple class="nav-link">Sedes</a></li>
                        <li><a href="/#footer"   (click)="navigate('#footer', $event)"   pRipple class="nav-link">Contacto</a></li>
                    </ul>
                </div>

                <div class="hidden lg:flex justify-content-end align-items-center flex-shrink-0">
                    <a [href]="loginUrl" class="user-link cursor-pointer text-center">
                        <i class="pi pi-user text-xl text-900"></i>
                        <span class="block">Log in</span>
                    </a>
                </div>

            </nav>
        </header>

    `,
    styles: [`
        .bg-usina-gray {
            background-color: var(--usina-bg);
        }

        /* Desktop Links */
        .nav-link {
            font-family: "ABCDiatype-Medium", sans-serif;
            font-size: 2.1rem; /* Anteriormente 2.8rem */
            line-height: 1.2;  /* Recomendado ajustar el interlineado al cambiar el tamaño */
            color: #000000;
            
            cursor: pointer;
            text-decoration: none;
            white-space: nowrap; /* Evita que se rompa en dos líneas */
            
        }

        .nav-link:hover {
            color: var(--usina-hover) !important;
            text-decoration: underline;
        }

        /* Mobile Links */
        .nav-link-mobile {
            font-family: "ABCDiatype-Medium", sans-serif;
            font-size: 20px;
            color: #f2f2f2ff;
            text-decoration: none;
        }
        .nav-link-mobile:hover {
             background-color: var(--surface-100);
        }

        /* Login Button */
        .user-link {
            text-decoration: none;
            color: #333333;
            min-width: 60px; /* Asegura un área de click decente */
        }
        .user-link span {
            font-family: "ABCDiatype-Regular", sans-serif;
            font-size: 12px;
        }
        .user-link:hover span {
             color: var(--usina-hover);
             text-decoration: underline;
        }
    `]
})
export class TopbarWidget {
    constructor(public router: Router) {}

    private platformId = inject(PLATFORM_ID);
    loginUrl = environment.userPanelUrl;

    navigate(id: string, event?: MouseEvent): void {
        // Prevenir la navegación nativa del href para usar smooth scroll
        if (event) event.preventDefault();

        if (this.router.url !== '/') {
            this.router.navigate(['/']).then(() => {
                setTimeout(() => this.smoothScroll(id), 100);
            });
        } else {
            this.smoothScroll(id);
        }
    }

    smoothScroll(id: string) {
        if (!isPlatformBrowser(this.platformId)) return;
        const element = document.querySelector(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
}